var _dec, _dec2, _class;
import { "BeanInfo" as __z_BeanInfo } from "zova";
import { cast } from 'zova';
import { BeanInterceptorBase, Interceptor, SymbolInterceptorBodyResponseFlag } from 'zova-module-a-fetch';
export let InterceptorBody = (_dec = Interceptor({
  dependencies: 'a-interceptor:performAction'
}), _dec2 = __z_BeanInfo({
  module: "a-interceptor"
}), _dec(_class = _dec2(_class = class InterceptorBody extends BeanInterceptorBase {
  async onResponse(response, _options, next) {
    response = await next();
    const contentType = response.headers['content-type'];
    if (!contentType || typeof contentType !== 'string' || !contentType.includes('application/json')) {
      response[SymbolInterceptorBodyResponseFlag] = true;
      return response;
    }
    if (response.data.code !== 0) {
      const error = new Error();
      error.code = response.data.code;
      error.message = response.data.message;
      throw error;
    }
    // return data
    return response.data.data ?? null;
  }
  async onResponseError(error, _options, next) {
    error = await next();
    if (!(error instanceof Error)) return error;
    if (error.response) {
      error.code = cast(error.response.data)?.code ?? error.response.status;
      error.message = cast(error.response.data)?.message ?? error.response.statusText;
    }
    return error;
  }
}) || _class) || _class);